import React from "react";
import { Routes, Route } from "react-router-dom";
import Footer from "@/components/Footer";
import HelpHeader from "./help/components/HelpHeader";
import HelpHome from "./help/index";
import ArticlesList from "./help/articles/index";
import ArticleDetail from "./help/articles/[slug]/index";

export default function Help() {
  return (
    <div className="min-h-screen">
      <HelpHeader />
      <Routes>
        <Route path="/" element={<HelpHome />} />
        <Route path="/articles" element={<ArticlesList />} />
        <Route path="/articles/:slug" element={<ArticleDetail />} />
        <Route path="*" element={<HelpHome />} />
      </Routes>
      <Footer />
    </div>
  );
}
